import type { ArtworkVenueType } from "~~/types/artwork";

export interface GalleryItem {
    title: string;
    type: ArtworkVenueType;
}

export const GALLERIES: GalleryItem[] = [
    { title: "Անձնական արվեստանոց", type: "private" },
    {
        title: "Ձիթողցոնց տուն-թանգարան",
        type: "museum",
    },
    {
        title: "Պ.Սևակ-ի տուն-թանգարան",
        type: "museum",
    },
    {
        title: "Գաֆեսջյանի արվեստի կենտրոն",
        type: "museum",
    },
    {
        title: "Հայաստանի պատմության թանգարան",
        type: "museum",
    },
    {
        title: "Գրականության և արվեստի թանգարան",
        type: "museum",
    },
    {
        title: "Միջին արևելքի թանգարան",
        type: "museum",
    },
    {
        title: "Հայաստանի երկաթուղու թանգարան",
        type: "museum",
    },
    {
        title: "Sisian History Museum",
        type: "museum",
    },
    {
        title: "Named after Hamo Sahyan",
        type: "arts_centre",
    },
    {
        title: "National Gallery",
        type: "arts_centre",
    },
    {
        title: "Աղվան Մինասյանի անվան երիտասարդական արվեստի կենտրոն",
        type: "arts_centre",
    },
    {
        title: "Հ.Հովհաննիսյանի անվան թանգարան",
        type: "museum",
    },
    {
        title: "Երվանդ Քոչար թանգարան",
        type: "museum",
    },
    {
        title: "Արամ Խաչատրյանի տուն թանգարան",
        type: "museum",
    },
    {
        title: "Սերգեյ Փարաջանովի թանգարան",
        type: "museum",
    },
    {
        title: "Մշակույթի տուն",
        type: "arts_centre",
    },
    {
        title: "Երևանի պատմության թանգարան",
        type: "museum",
    },
    {
        title:
            "Հայաստանի ազգագրության և ազգային-ազատագրական պայքարի պետական թանգարան «Սարդարապատ»",
        type: "museum",
    },
    {
        title: "Վազգեն Սարգսյանի տուն-թանգարան",
        type: "museum",
    },
    {
        title: "Դերասանի Տուն",
        type: "arts_centre",
    },
    {
        title: "Մուշեղ Գալշոյանի տեւն-թանգարան",
        type: "museum",
    },
    {
        title: "History museum",
        type: "museum",
    },
    {
        title: "Հնագիտության թանգարան",
        type: "museum",
    },
    {
        title: "Ժամանակակից արվեստի թանգարան",
        type: "museum",
    },
    {
        title: "Frigi Jiraff",
        type: "arts_centre",
    },
    {
        title: "«ԴԻՍՆԵՅ» արվեստի դպրոց",
        type: "arts_centre",
    },
    {
        title: "Կարեն Դեմիրճյանի տուն-թանգարանը ",
        type: "museum",
    },
    {
        title: "Հյաստանի ազգային թանգարան (Ալավերդի մասնաճյուղ)",
        type: "museum",
    },
    {
        title: "Հովհաննես Թումանյանի տուն-թանգարան",
        type: "museum",
    },
    {
        title: "Դալան պատկերասրահը",
        type: "gallery",
    },
    {
        title: "Արարատ կոնյակի թանգարան",
        type: "museum",
    },
    {
        title: "Պատմական թանգարան",
        type: "museum",
    },
    {
        title: "Ավետիք Իսահակյանի տուն-թանգարան",
        type: "museum",
    },
    {
        title: "Մհեր Մկրտչյանի տեւն-թանգարան",
        type: "museum",
    },
    {
        title: "Մինաս Ավետիսյանի անվան կերպարվեստի դպրոց",
        type: "arts_centre",
    },
    {
        title: "Tatev Oil Mill",
        type: "museum",
    },
    {
        title: "Մատենադարան",
        type: "museum",
    },
    {
        title: "«ՎԱԼՄԱՐ» ԱՐՎԵՍՏԻ ՍՐԱՀ",
        type: "arts_centre",
    },
    {
        title: "Ասլամազյան քույրերի պատկերասրահ",
        type: "museum",
    },
    {
        title: "Կումայրի հնագիտական թանգարան",
        type: "museum",
    },
    {
        title: "Style Gallery",
        type: "gallery",
    },
    {
        title: "Մշակույթի տուն",
        type: "arts_centre",
    },
    {
        title: "Վանաձորի Կոմիտասի անվան արվեստի դպրոց",
        type: "arts_centre",
    },
    {
        title: "Ալեքսանդր Սպենդիարյանի տուն-թանգարան",
        type: "museum",
    },
    {
        title: "Սերո Խանզադյան թանգարան",
        type: "museum",
    },
    {
        title: "Ժողովրդական Արվեստների Թանգարան",
        type: "museum",
    },
    {
        title: "Ակսել Բակունցի տուն-թանգարան",
        type: "museum",
    },
    {
        title: "Նոր Արվեստանոց",
        type: "museum",
    },
    {
        title: "Գրատպության թանգարան",
        type: "museum",
    },
    {
        title: "Բերդի Պատմության Թանգարան",
        type: "museum",
    },
    {
        title: "Շիրակի երկրագիտական թանգարան",
        type: "museum",
    },
    {
        title: "Yeghishe Charents Memorial Museum",
        type: "museum",
    },
    {
        title: "Երևանի ռուսական արվեստի թանգարան",
        type: "museum",
    },
    {
        title: "Կինոյի տուն",
        type: "arts_centre",
    },
    {
        title: "Երկրաբանական թանգարան",
        type: "museum",
    },
    {
        title: "Արա Սարգսյանի և Հակոբ Կոջոյանի տուն-թանգարան",
        type: "museum",
    },
    {
        title: "Հովսեփ Մարգարյանի տուն-թանգարան",
        type: "museum",
    },
    {
        title: "Tumanyan Matchbox Label Museum",
        type: "museum",
    },
    {
        title: "Nexus Center for the Arts",
        type: "arts_centre",
    },
    {
        title: '"RAMBALKOSHE"',
        type: "arts_centre",
    },
    {
        title: "Գիտության և տեխնոլոգիայի թանգարան",
        type: "museum",
    },
    {
        title: "Museum of Regional Studies",
        type: "museum",
    },
    {
        title: "ՌաՄան",
        type: "arts_centre",
    },
    {
        title: "Арт Галлерия",
        type: "gallery",
    },
    {
        title: "Two arcs",
        type: "gallery",
    },
    {
        title: "Հայաստանի ազգային կինոկենտրոն",
        type: "arts_centre",
    },
    {
        title:
            "Ալեքսանդր Թամանյանի անվան ճարտարապետության ազգային թանգարան-ինստիտուտ",
        type: "museum",
    },
    {
        title: "Հայաստանի բնության պետական թանգարան",
        type: "museum",
    },
    {
        title: "Zoravar Andranik museum dedicated to Fidai movement",
        type: "museum",
    },
    {
        title: "Սիլվա Կապուտիկյանի տուն թանգարան",
        type: "museum",
    },
    {
        title: "Հայաստանի ազգային օլիմպիական թանգարան",
        type: "museum",
    },
    {
        title: "Մայր Հայաստան",
        type: "museum",
    },
    {
        title: "Նորարար Փորձառական Արվեստի Կենտրոն",
        type: "museum",
    },
    {
        title: "Form & Seasons",
        type: "gallery",
    },
    {
        title: "Նիկոլայ Նիկողոսյան Մշակութային Հիմնադրամ",
        type: "arts_centre",
    },
    {
        title: "Danieljan",
        type: "arts_centre",
    },
    {
        title: "Անդրանիկ Ավետիսյանի սարդոստայն արվեստի սատկերասրահ",
        type: "gallery",
    },
    {
        title: "Ազգային Սինեմատեք Կինոթանգարան",
        type: "museum",
    },
    {
        title: "Soviet Club",
        type: "museum",
    },
    {
        title: "Gallery by Melikyan, շրջանակների խանութ",
        type: "gallery",
    },
    {
        title: "ԿԲ Այցելուների կենտրոն",
        type: "museum",
    },
    {
        title: "Կապանի արվեստի թանգարան",
        type: "museum",
    },
    {
        title: "Erebuni Cultural Center",
        type: "arts_centre",
    },
    {
        title: "Վիկտոր Համբարձումյանի տուն թանգարան",
        type: "museum",
    },
    {
        title: "Հայկական դրամի թանգարան",
        type: "museum",
    },
    {
        title: "Avetiq Harutyunyan Art Gallery",
        type: "gallery",
    },
    {
        title: "Հայկական տեքստիլի թանգարան",
        type: "museum",
    },
    {
        title: "Մարտիրոս Սարյանի տուն-թանգարան",
        type: "museum",
    },
    {
        title: "Երևանի Մատենադարան",
        type: "museum",
    },
    {
        title: "Էրեբունի ամրոցի թանգարան",
        type: "museum",
    },
    {
        title: "Խաչատուր Աբովյան",
        type: "museum",
    },
    {
        title: "Հովհաննես Թումանյանի տուն–թանգարան",
        type: "museum",
    },
    {
        title: "Շենգավիթ",
        type: "museum",
    },
    {
        title: "Կերպարվեստի Թանգարան",
        type: "museum",
    },
    {
        title: "Զվարթնոց արգելոց թանգարան",
        type: "museum",
    },
    {
        title: "Ստեփան Զորյանի տուն թանգարան",
        type: "museum",
    },
    {
        title: "Ճեմարան",
        type: "museum",
    },
    {
        title: "Էջմիածնի պատմաազգագրական թանգարան",
        type: "museum",
    },
    {
        title: "Ալեք և Մարի Մանուկյան Գանձատուն",
        type: "museum",
    },
    {
        title: "Ստեփան Շահումյանի թանգարան",
        type: "museum",
    },
    {
        title: "Միկոյան եղբայների թանգարան",
        type: "museum",
    },
    {
        title: "Դիլիջանի երկրագիտական թանգարան-պատկերասրահ",
        type: "museum",
    },
    {
        title: "Ijevan Local Lore museum",
        type: "museum",
    },
    {
        title: "Իջևանի Պատմաերկրագիտական Թանգարան",
        type: "museum",
    },
    {
        title: "Օրբելի եղբայրների թանգարան",
        type: "museum",
    },
    {
        title: "Metsamor historical-archeological museum-reserve",
        type: "museum",
    },
    {
        title: "Գլաձորի Համալսարան",
        type: "museum",
    },
    {
        title: "Մշակույթի տուն",
        type: "arts_centre",
    },
    {
        title: "Կոմիտասի թանգարան-ինստիտուտ",
        type: "museum",
    },
    {
        title: '"էդուարդ Իսաբեկյան" ցուցասրահ',
        type: "gallery",
    },
    {
        title: "Շառլ Ազնավուրի կեցավայր",
        type: "museum",
    },
    {
        title: "Խորեն Տեր-Հարությանի թանգարան",
        type: "museum",
    },
    {
        title: "Պարարվեստի դպրոց",
        type: "arts_centre",
    },
    {
        title: "<<Ժան և Ալբեր Պողոսյանների>> անվ. արվեստի քոլեջ",
        type: "arts_centre",
    },
    {
        title: "Մշակույթի տուն",
        type: "arts_centre",
    },
    {
        title: "Բուսաբանական թանգարան",
        type: "museum",
    },
    {
        title: "House of Culture",
        type: "arts_centre",
    },
    {
        title: "Perch Proshyan House-Museum",
        type: "museum",
    },
    {
        title: "Կալենցի Թանգարան",
        type: "museum",
    },
    {
        title: "Կապանի երկրագիտական թանգարան",
        type: "museum",
    },
    {
        title: "ՀՈՎՀԱՆՆԵՍ ՇԻՐԱԶԻ ՀՈՒՇԱՏՈՒՆ-ԹԱՆԳԱՐԱՆ",
        type: "museum",
    },
    {
        title: "Timeland",
        type: "museum",
    },
    {
        title: "Լուսիկ Ագուլեցի",
        type: "museum",
    },
    {
        title: "Հրանտ Մաթևոսյանի անվան թանգարան-մշակութային կենտրոն",
        type: "museum",
    },
    {
        title: "Ֆրիտյոֆ Նանսենի թանգարան",
        type: "museum",
    },
    {
        title:
            "Մուսալեռան Հերոսամարտի Պատմության Եվ Մուսալեռցիների Ազգագրության Թանգարան",
        type: "museum",
    },
    {
        title: "Ազգային պատկերասրահ",
        type: "museum",
    },
    {
        title: "Ցեղասպանության թանգարան",
        type: "museum",
    },
    {
        title: "Ղարաբաղյան պատերազմում զոհված զինվորների թանգարան",
        type: "museum",
    },
];
